import React, { createElement } from 'react';
import { Navigate, Route } from 'react-router-dom';
import AnimatedRouter from 'components/AnimatedRouter';
import ScrollTop from 'components/ScrollTop';
import Title from 'components/Title';
import routeConfig from 'stores/menu';
import Demo from '../../Demo';
import Notify from '../Notify';
import Breadcrumb from './Breadcrumb';
import Header from './Header';
import './style.scss';

const Profile: React.FC = () => {
    return (
        <div className="profile-root">
            <Notify />
            <Header />
            <Breadcrumb />
            <AnimatedRouter className="profile-content">
                {routeConfig().map(({ title, isVisible, element, ...routeProps }) =>
                    !isVisible || isVisible() ? (
                        <Route
                            key={routeProps.path}
                            path={routeProps.path}
                            index={routeProps.path === '/'}
                            element={
                                <>
                                    <Title title={title} />
                                    {createElement(element)}
                                    <ScrollTop to={routeProps.path === '/' ? undefined : '.profile-bread'} />
                                </>
                            }
                        />
                    ) : null
                )}
                {process.env.NODE_ENV === 'development' && <Route path="demo" element={<Demo />} />}
                <Route path="*" element={<Navigate to="." replace />} />
            </AnimatedRouter>
        </div>
    );
};

export default Profile;
